import { Container, Typography } from "@mui/material";
import { Grid, Box, Button } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import EuroIcon from "@mui/icons-material/Euro";
import Paper from "@mui/material/Paper";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { useStyles } from "./piechartcard-styles";
import { useTheme } from "@mui/material/styles";

import {
  RadialBarChart,
  RadialBar,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { borderRadius } from "@mui/system";

let data = [
  {
    name: "30-34",
    uv: -15.69,
    pv: 1398,
    fill: "#8dd1e1",
  },
  {
    name: "35-39",
    uv: 8.22,
    pv: 9800,
    fill: "#82ca9d",
  },

  {
    name: "50+",
    uv: -2.63,
    pv: 4800,
    fill: "#d0ed57",
  },
  {
    name: "unknow",
    uv: 6.67,
    pv: 4800,
    fill: "#ffc658",
  },
];

// const chartLabel == () => {

// }

const RadialChart = () => {
  const theme = useTheme();
  let temp_data = [];

  for (let i = 0; i < data.length; i++) {
    if (i % 2 !== 0) {
      temp_data.push({ ...data[i], fill: theme.palette.primary.main });
    } else {
      temp_data.push({ ...data[i], fill: theme.palette.secondary.main });
    }
  }

  data = temp_data;

  return (
    <ResponsiveContainer width="99%">
      <RadialBarChart
        width={730}
        height={250}
        innerRadius="30%"
        outerRadius="100%"
        // style={
        //   borderRadius:"40%"
        // }

        data={data}
        startAngle={90}
        endAngle={-180}
      >
        <RadialBar
          // radius={[10, 0, 0, 10]}

          minAngle={15}
          // label={{ fill: "#000" ,position:"insideStart",offset: -10  }}
          background
          clockWise={true}
          dataKey="pv"
          legendType="line"
        />

        <Legend
          iconSize={10}
          width={100}
          height={40}
          layout="vertical"
          verticalAlign="top"
          align="left"
        />

        <Tooltip />
      </RadialBarChart>
    </ResponsiveContainer>
  );
};

export const PieChartCard = () => {
  const classes = useStyles();

  return (
    <Paper className={classes.paper} variant="elevation" elevation={0}>
      <Box className={classes.cardContentsWrapper}>
        <Box className={classes.cardTextArea}>
          <Typography variant="h6" className={classes.cardHeader}>
            Growth Overview
          </Typography>

          <Typography className={classes.cardText}>
            <Avatar className={classes.percentageChangeAvatarIcon}>
              <ShowChartIcon />
            </Avatar>
            95.54% Growth
          </Typography>
        </Box>

        <Box sx={{ height: "20rem" }}>
          <RadialChart />
        </Box>
      </Box>
    </Paper>
  );
};
